module.exports = __webpack_public_path__ + "img/Man-10.8c4c04ef.svg";